export default "__VITE_ASSET__53f2ed49__"